const spendAnalytics = {
  id: 'spendAnalytics',
  title: 'Spend Intelligence',
  type: 'group',
  children: [
    {
      id: 'spendAnalyticsItem',
      title: 'Spend Intelligence',
      type: 'item',
      url: '/spend-analytics/analysis',
      icon: 'mdi:chart-bar',
      breadcrumbs: false,
    },
  ],
};

export default spendAnalytics;
